import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { getToken } from '../utils/auth';

const ProjectNameContext = createContext();

export const useProjectName = () => useContext(ProjectNameContext);

export const ProjectNameProvider = ({ children }) => {
    const [projectName, setProjectName] = useState('');


    const handleCategories = async () => {
        try {
          const token = getToken();
          const response = await axios.get(
            `${process.env.REACT_APP_URL}/api/default-setting`, {
              headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "multipart/form-data"
              }
            }
          );
          const data = response.data.data.isDefaultSettingsExist;
          // console.log("Categories Fetched Successfully", data);
          setProjectName(data?.projectName)
      
        } catch (error) {
          console.error("Failed Fetching Categories", error);
        }
      };

      useEffect(()=>{
        handleCategories();
      },[])
      // console.log("projectName",projectName)
    return (
        <ProjectNameContext.Provider value={projectName}>
            {children}
        </ProjectNameContext.Provider>
    );
};
